import { router } from "@/router";
import { MenuData } from "../base/MenuData";
import bus from "./Bus";

export class ViewUtil {
    public static toDetailView(groupUrl: string, url: string, id: number): void {
        router.push({
            path: url,
            query: { id, type: "M", cache: "0" }
        });
        const menuData: MenuData = {
            name: groupUrl,
            path: url,
            query: { id: id, type: "M", cache: "1" },
            isClose: true
        };
        bus.emit("to-detail", menuData);
    }

    public static toListView(url: string, title: string, param: any): void {
        router.push({
            path: url,
            query: param
        });

        const menuData: MenuData = {
            name: url,
            path: url,
            title: title,
            isClose: true
        };
        bus.emit("menu-select", menuData);
    }
}
